import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CustomRolesPage,
  RoleBundlesPage,
  STAFF_PERMISSION_GLOBAL_ONLY_ROUTE_DATA,
  STAFF_PERMISSION_ROUTE_DATA,
  StaffRoleGuard,
  TeamMembersPage,
} from '@wsphere/staff/web';
import {
  AppsPage,
  DeveloperPage,
  EmailPage,
  EmailTemplatesPage,
  EmailsPage,
  FeatureFlagsPage,
  OrganizationPage,
} from './pages';
import { CustomRolesFeatureGuard } from './guards/custom-roles-feature.guard';
import { TenantsWebModule } from './tenants-web.module';

@NgModule({
  imports: [
    TenantsWebModule,
    RouterModule.forChild([
      {
        path: '',
        component: OrganizationPage,
      },
      {
        path: 'team',
        component: TeamMembersPage,
      },
      {
        path: 'roles',
        component: CustomRolesPage,
        canActivate: [CustomRolesFeatureGuard, StaffRoleGuard],
        data: { [STAFF_PERMISSION_ROUTE_DATA]: '*', [STAFF_PERMISSION_GLOBAL_ONLY_ROUTE_DATA]: true },
      },
      {
        // Bundles are not behind the custom-roles flag; they group roles regardless of where those roles come from.
        path: 'role-bundles',
        component: RoleBundlesPage,
        canActivate: [StaffRoleGuard],
        data: { [STAFF_PERMISSION_ROUTE_DATA]: '*', [STAFF_PERMISSION_GLOBAL_ONLY_ROUTE_DATA]: true },
      },
      {
        path: 'apps',
        component: AppsPage,
      },
      {
        path: 'communications',
        component: EmailTemplatesPage,
      },
      {
        path: 'feature-flags',
        component: FeatureFlagsPage,
      },
      {
        path: 'developer',
        component: DeveloperPage,
      },
      {
        path: 'emails',
        children: [
          {
            path: '',
            component: EmailsPage,
            canActivate: [StaffRoleGuard],
            data: { [STAFF_PERMISSION_ROUTE_DATA]: '*' },
          },
          {
            path: ':emailId',
            component: EmailPage,
            canActivate: [StaffRoleGuard],
            data: { [STAFF_PERMISSION_ROUTE_DATA]: '*' },
          },
        ],
      },
    ]),
  ],
  providers: [CustomRolesFeatureGuard],
})
export class TenantWebRoutingModule {}
